<template>
  <div class="aba-societario-oportunidade">
    <div class="societario-header">
      <div>
        <h5 class="mb-0">
          Societário
        </h5>
        <small class="text-muted">Informações do cadastro da empresa</small>
      </div>
    </div>

    <div
      v-if="carregando"
      class="text-muted py-2"
    >
      Carregando...
    </div>

    <div v-else>
      <b-row>
        <b-col
          cols="4"
          class="mb-1"
        >
          <div class="societario-card">
            <div class="societario-card-label">
              Capital Social
            </div>
            <div class="societario-card-value">
              {{ capitalSocialExibicao }}
            </div>
          </div>
        </b-col>
      </b-row>

      <div
        v-if="sociosNormalizados.length === 0"
        class="text-muted mt-1"
      >
        Atenção: não há sócios vinculados a esta empresa.
      </div>

      <b-table
        v-else
        small
        responsive
        :items="sociosNormalizados"
        :fields="fields"
        class="mt-1"
      >
        <template #cell(valorSocietaria)="{ item }">
          {{ formatarValor(item.valorSocietaria) }}
        </template>
        <template #cell(porcentagemSocietaria)="{ item }">
          {{ formatarPercentual(item.porcentagemSocietaria) }}
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AbaSocietarioOportunidade',
  props: {
    empresa: {
      type: Object,
      required: false,
      default: null,
    },
    carregando: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fields: [
        { key: 'nome', label: 'Nome' },
        { key: 'inscricao', label: 'Inscrição' },
        { key: 'email', label: 'E-mail' },
        { key: 'porcentagemSocietaria', label: '%' },
        { key: 'valorSocietaria', label: 'Capital Integralizado' },
        { key: 'dataNascimento', label: 'Data de nascimento' },
        { key: 'dataEntrada', label: 'Data de entrada' },
        { key: 'dataSaida', label: 'Data de saída' },
      ],
    }
  },
  computed: {
    capitalSocialExibicao() {
      const emp = this.empresa || {}
      const raw = emp.capitalSocial !== undefined ? emp.capitalSocial : emp.CapitalSocial
      if (raw === null || raw === undefined || raw === '') return '—'
      return this.formatarValor(raw)
    },
    sociosNormalizados() {
      const emp = this.empresa || {}
      const sociosRaw = emp.socios || emp.Socios || []
      const arr = Array.isArray(sociosRaw) ? sociosRaw : []
      return arr.map(s => {
        const nome = this.toStringTrim(s.nome || s.Nome)
        const inscricao = this.toStringTrim(s.inscricao || s.Inscricao || s.cpf || s.CPF)
        const email = this.toStringTrim(s.email || s.Email)
        const porcentagemSocietaria = this.toStringTrim(s.porcentagemSocietaria || s.PorcentagemSocietaria)
        const valorSocietaria = s.valorSocietaria !== undefined ? s.valorSocietaria : s.ValorSocietaria
        const dataNascimento = this.normalizarData(s.dataNascimento || s.DataNascimento)
        const dataEntrada = this.normalizarData(s.dataEntrada || s.DataEntrada)
        const dataSaida = this.normalizarData(s.dataSaida || s.DataSaida)

        return {
          nome: nome || '—',
          inscricao: inscricao || '—',
          email: email || '—',
          porcentagemSocietaria: porcentagemSocietaria || '—',
          valorSocietaria: valorSocietaria === null || valorSocietaria === undefined || valorSocietaria === '' ? null : valorSocietaria,
          dataNascimento: dataNascimento || '—',
          dataEntrada: dataEntrada || '—',
          dataSaida: dataSaida || '—',
        }
      })
    },
  },
  methods: {
    toStringTrim(v) {
      if (v === null || v === undefined) return ''
      return String(v).trim()
    },
    normalizarData(v) {
      if (!v) return ''
      const raw = String(v).trim()
      if (!raw) return ''
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(raw)) return raw
      const m = raw.match(/^(\d{4})-(\d{2})-(\d{2})/)
      if (m) return `${m[3]}/${m[2]}/${m[1]}`
      return raw
    },
    formatarValor(valor) {
      if (valor === null || valor === undefined || valor === '') return '—'
      const n = typeof valor === 'string' ? Number(valor.replace(/\./g, '').replace(',', '.')) : Number(valor)
      const safe = Number.isFinite(n) ? n : valor
      try {
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(safe)
      } catch (e) {
        return String(valor)
      }
    },
    formatarPercentual(valor) {
      if (valor === null || valor === undefined || valor === '' || valor === '—') return '—'
      const raw = String(valor).trim()
      if (!raw) return '—'
      if (raw.endsWith('%')) return raw
      return `${raw}%`
    },
  },
}
</script>

<style>
.aba-societario-oportunidade {
  padding: 8px;
}

.societario-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.societario-card {
  border: 1px solid #e9ecef;
  border-radius: 10px;
  padding: 12px 14px;
  background: #fff;
}

.societario-card-label {
  font-size: 12px;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.societario-card-value {
  font-size: 18px;
  font-weight: 700;
  margin-top: 4px;
}
</style>
